import map from 'lodash/map';
import { useDispatch } from 'react-redux';
import { useEffect, useMemo } from 'react';

import rolesResource from 'src/actions/roles/rolesResource';
import { toastError } from 'src/actions/toast';
import useResource, {
  getConsolidatedState,
  ResourceStatus,
  someFailed,
  STATUS_FAILED,
  STATUS_SUCCEEDED,
} from 'src/presentation/hooks/useResource';
import { Role } from 'src/actions/roles/rolesResource';

interface UseRolesResult {
  roles: Role[];
  errors: string[];
  resetErrors: () => void;
  loadingState: ResourceStatus;
}

const useRoles = (): UseRolesResult => {
  const dispatch = useDispatch();
  const { resetErrors } = rolesResource.actions as any;

  const {
    values: roles,
    errors: rolesErrors,
    loadingState: rolesLoadingState,
  } = useResource(rolesResource, { fetch: true }, false); // unloadOnUnmount - false

  const loadingStates = [rolesLoadingState];
  const fetchError = someFailed(...loadingStates);
  const loadingState = fetchError ? STATUS_FAILED : getConsolidatedState(loadingStates);

  const rolesExtended = useMemo(() => {
    if (rolesLoadingState !== STATUS_SUCCEEDED || !roles) {
      return [];
    }
    return map(roles, role => ({ ...role }));
  }, [roles, rolesLoadingState]);

  useEffect(() => {
    if (fetchError) {
      dispatch(toastError('Error while loading data. Please wait and try refreshing the page'));
    }
  }, [fetchError, dispatch]);

  return {
    roles: rolesExtended,
    errors: rolesErrors,
    resetErrors,
    loadingState,
  };
};

export default useRoles;
